<template>
  <PageWrapper>
    <ds-breadcrumb>
      <ds-breadcrumb-item>账号中心</ds-breadcrumb-item>
      <ds-breadcrumb-item>账号信息</ds-breadcrumb-item>
    </ds-breadcrumb>
    <div class="account-info">
      <div v-ds-loading="loading" class="account-info__content">
        <div class="account-info__form">
          <ds-form ref="ruleForm" :model="formData" label-width="90px" label-position="left">
            <p class="account-info__title">
              基础信息
            </p>
            <div class="account-info__border">
              <ds-form-item label="账号名称：">
                {{ dataUser.userName }}
                <ds-button class="account-info__button" type="text" icon="ds-icon-edit" @click="goEditPassword">
                  修改密码
                </ds-button>
              </ds-form-item>
              <ds-form-item v-if="$store.getters.isAdmin" label="实名认证：">
                {{ certificationStatus }}
                <ds-button
                  v-if="certificationStatus === '未认证'"
                  class="account-info__button"
                  type="text"
                  icon="ds-icon-yonghuxinxi"
                  @click="handleRegister"
                >
                  快速进行认证
                </ds-button>
                <ds-button
                  v-else-if="certificationStatus === '认证失败'"
                  class="account-info__button"
                  type="text"
                  icon="ds-icon-yonghuxinxi"
                  @click="handleRegister"
                >
                  重新提交认证>>
                </ds-button>
              </ds-form-item>
              <ds-form-item label="所属组织：">
                {{ dataUser.customerName }}
              </ds-form-item>
              <ds-form-item v-if="accountType === '企业'" label="所属部门：" style="margin-bottom: 0px">
                <ul class="account-info__form-box-ul">
                  <li v-for="item in dataUser.departments" :key="item.departmentId" class="account-info__form-box-li">
                    <div class="account-info__form-box-li-title">
                      {{ item.departmentName }}
                    </div>
                    <div class="account-info__form-box-li-desc">
                      {{ item.identity | identityFilter }}
                    </div>
                  </li>
                </ul>
              </ds-form-item>
            </div>
            <p class="account-info__title">
              安全设置
            </p>
            <div class="account-info__border">
              <template v-if="!verifiedData.isShow">
                <ds-form-item label="绑定手机：">
                  <span>{{ dataUser.userPhone }}</span>
                  <span
                    v-if="dataUser.phoneVerified === 'false'"
                    class="account-info__form-verified"
                    @click="verifiedEvent"
                  >&nbsp;去验证>>
                  </span>
                </ds-form-item>
              </template>
              <div v-else>
                <ds-form-item
                  :rules="[{ validator: validate, trigger: ['blur', 'change'] }]"
                  label="手机："
                  prop="phone"
                >
                  <div class="account-info__form-phone-verified">
                    <ds-input v-model="formData.phone" class="account-info__form-input" size="small" />
                    <span v-if="!verifiedData.isShowCountTime" class="account-info__form-verified-text">
                      <ds-button size="small" :loading="formLoading.phoneLoading" type="text" @click="verifycodeEvent">
                        {{ verifiedData.name }}
                      </ds-button>
                    </span>
                    <span
                      v-else
                      class="account-info__form-verified-text account-info__form-warn"
                    >{{ verifiedData.time }}秒</span
                    >
                  </div>
                </ds-form-item>
                <ds-form-item
                  v-show="verifiedData.isSend"
                  :rules="[{ validator: validateNum, trigger: ['blur', 'change'] }]"
                  label="验证码："
                  prop="num"
                >
                  <div class="account-info__form-phone-verified">
                    <ds-input v-model="formData.num" class="account-info__form-input" size="small" />
                    <span class="account-info__form-verified-text">
                      <ds-button size="small" type="primary" :loading="formLoading.validateLoading" @click="submitForm">
                        确认
                      </ds-button>
                    </span>
                  </div>
                </ds-form-item>
              </div>
              <ds-form-item label="绑定邮箱：">
                {{ dataUser.userEmail }}
              </ds-form-item>
            </div>
            <p class="account-info__title">
              权限信息
            </p>
            <ds-form-item label="产品及角色：">
              <ul class="account-info__form-box-ul">
                <li v-for="item in dataUser.roles" :key="item.roleId" class="account-info__form-box-li">
                  <div class="account-info__form-box-li-title">
                    {{ item.productName }}
                  </div>
                  <div class="account-info__form-box-li-desc">
                    {{ item.roleName }}
                  </div>
                  <!-- {{ item.productName }}&nbsp;| &nbsp;{{ item.roleName }}； -->
                </li>
              </ul>
            </ds-form-item>
          </ds-form>
        </div>
      </div>
    </div>
  </PageWrapper>
</template>

<script>
import PageWrapper from '@/components/PageWrapper'
import { isPhoneValid } from '@/util/isPhoneValid.ts'

const COUNTTIME = 60

export default {
  name: 'Home',
  filters: {
    identityFilter(val) {
      return val === 'superiorStaff' ? '上级' : '普通成员'
    }
  },
  components: {
    PageWrapper
  },
  data() {
    var validate = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'))
      } else {
        if (!isPhoneValid(this.formData.phone)) {
          callback(new Error('请正确的手机号码'))
        }
        callback()
      }
    }
    var validateNum = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'))
      } else {
        callback()
      }
    }
    return {
      formData: {
        phone: '',
        num: ''
      },
      rules: {
        phone: [{ validator: validate, trigger: ['blur', 'change'] }],
        num: [{ validator: validateNum, trigger: ['blur'] }]
      },
      dataUser: {},
      verifiedData: {
        isShow: false,
        name: '获取验证码',
        time: COUNTTIME,
        isShowCountTime: false,
        isSend: false,
        intervalTime: null
      },
      loading: false,
      formLoading: {
        phoneLoading: false,
        validateLoading: false
      },
      thirdPartArr: [{
        name: '绑定微信',
        icon: 'ds-icon-login-weixin',
        sign: 'wechat',
        loading: false,
        backSign: 'weChatBind',
        isBind: false,
        userNameBackSign: 'weChatNickName',
        userName: ''
      }, {
        name: '绑定钉钉',
        icon: 'ds-icon-login-dingding',
        sign: 'dingding',
        loading: false,
        backSign: 'dingTalkBind',
        isBind: false,
        userNameBackSign: 'dingTalkNickName',
        userName: ''
      }],
    }
  },
  computed: {
    accountType() {
      switch (this.dataUser.accountType) {
        case 'customer':
          return '企业'
        case 'individual':
          return '个人'
        default:
          return ''
      }
    },
    certificationStatus() {
      switch (this.dataUser.certifiedStatus) {
        case 'UNCERTIFICATED':
          return '未认证'
        case 'PENDING':
          return '审核中'
        case 'VERIFIED':
          return `${this.accountType}认证成功`
        case 'REFUSED':
          return '认证失败'
        default:
          return ''
      }
    },
  },
  mounted() {
    this.userDetailPort()
  },
  beforeDestroy() {
    clearInterval(this.verifiedData.intervalTime)
  },
  methods: {
    init() {
      // 判断之前获取验证码之后是不是在验证码的时间之内进行了页面刷新和跳转,如是就要显示之前的操作
      const diffTime = localStorage.getItem('diffTime')
      if (diffTime) {
        const diffObj = JSON.parse(diffTime)
        // 获取两者之差
        const SECOND = 1000
        const diff = Math.floor((new Date().getTime() - new Date(diffObj.diffTime).getTime()) / SECOND)
        if (diff < COUNTTIME) {
          this.formData.phone = diffObj.userPhone
          this.verifiedData.isShow = true
          this.verifiedData.isShowCountTime = true
          this.verifiedData.isSend = true
          this.countTime(COUNTTIME - diff)
        }
      }
    },
    userDetailPort() {
      // 在 router guard 里就已经拿到了 userData 了，没必要再拿一次
      this.dataUser = this.$store.state.userData
      this.thirdPartArr.map(item => {
        item.isBind = this.dataUser[item.backSign]
        item.userName = this.dataUser[item.userNameBackSign]
      })
      this.init()
    },
    validate(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入手机号'))
      } else {
        if (!isPhoneValid(this.formData.phone)) {
          callback(new Error('请正确的手机号码'))
        }
        callback()
      }
    },
    validateNum(rule, value, callback) {
      if (value === '') {
        callback(new Error('请输入验证码'))
      } else {
        callback()
      }
    },
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.verifycodePort()
        } else {
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
    // 去验证按钮点击
    verifiedEvent() {
      this.formData.phone = this.dataUser.userPhone
      this.verifiedData.isShow = true
    },
    // 验证码发送事件
    verifycodeEvent() {
      if (this.formData.phone === '' || !isPhoneValid(this.formData.phone)) {
        this.$refs.ruleForm.validateField('phone')
        return false
      }
      this.sendCodePort()
    },
    sendCodePort() {
      this.formLoading.phoneLoading = true
      this.$ucProxy({
        url: '/user/phone/verifycode',
        type: 'get',
        data: {
          userPhone: this.formData.phone
        }
      }).then(res => {
        this.formLoading.phoneLoading = false
        this.verifiedData.isSend = true
        this.verifiedData.isShowCountTime = true
        const obj = {
          diffTime: new Date(),
          userPhone: this.formData.phone
        }

        localStorage.setItem('diffTime', JSON.stringify(obj))
        this.countTime(COUNTTIME)
      }).catch(() => {
        this.formLoading.phoneLoading = false
      })
    },
    verifycodePort() {
      this.formLoading.validateLoading = true
      this.$ucProxy({
        url: '/user/phone/verify',
        type: 'get',
        data: {
          code: this.formData.num,
          userPhone: this.formData.phone
        }
      }).then(res => {
        this.formLoading.validateLoading = false
        this.$dsMessage({
          message: '验证成功',
          type: 'success'
        })
        this.dataUser.phoneVerified = 'true'
        localStorage.removeItem('diffTime')
        this.dataUser.userPhone = this.formData.phone
        this.$store.commit('SET_USER', this.dataUser)
        this.verifiedData.isShow = false
      }).catch(e => {
        this.formLoading.validateLoading = false
      })
    },
    // 验证码倒计时
    countTime(time) {
      this.verifiedData.time = time
      const count = () => {
        if (this.verifiedData.time <= 0) {
          clearInterval(this.verifiedData.intervalTime)
          this.verifiedData.isShowCountTime = false
          localStorage.removeItem('diffTime')
          return false
        }
        this.verifiedData.time--
      }
      const timeInterval = 1000
      this.verifiedData.intervalTime = setInterval(() => {
        count()
      }, timeInterval)
    },
    goEditPassword() {
      this.$router.push({ name: 'EditPassword' })
    },
    thirdPartEvent(item, sign) {
      let type = ''
      switch (item.sign) {
        case 'wechat':
          type = 'weChat'
          break
        case 'dingding':
          type = 'dingTalk'
          break
      }
      if (sign === 'cancel') {
        const text = item.sign === 'wechat' ? '微信' : '钉钉'
        this.$confirm(`解绑${text}后你将无法使用${text}登录，你确定解绑吗？`, '提示', {
          confirmButtonText: '解绑',
          cancelButtonText: '暂不解绑',
          type: 'warning'
        }).then(() => {
          this.thirdPartCancelBindPort(type, item)
        }).catch(() => {
        })
      } else {
        this.thirdPartPort(type, item)
      }
    },
    async thirdPartPort(type, row) {
      row.loading = true
      try {
        const res = await this.$ucProxy({
          url: `/user/qrBind/${type}`,
          type: 'get',
          data: {
            redirectUrl: window.location.href,
            link: true
          }
        })
        row.loading = false
        if (res.success) {
          window.open(res.data)
        }
      } catch (error) {
        // console.log(error)
        row.loading = false
      }
    },
    async thirdPartCancelBindPort(type, row) {
      row.loading = true
      try {
        const res = await this.$ucProxy({
          url: `/user/qrUnBind/${type}`,
          type: 'get'
        })
        row.loading = false
        if (res.success) {
          this.$dsMessage({
            message: '解绑成功',
            type: 'success'
          })
          this.userDetailPort()
        }
      } catch (error) {
        row.loading = false
      }
    },
    handleRegister() {
      let type
      if (this.accountType === '个人') {
        type = 'individual'
      } else if (this.accountType === '企业') {
        type = 'customer'
        this.$dsMessage('功能待开放')
        return
      }
      this.$router.push({
        name: 'Certificate',
        query: {
          type,
          redirect_url: window.location.href,
        },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.account-info {
  position: relative;
  background: var(--ds-color-A--background);

  &__pt20 {
    padding-top: 20px;
  }

  &__form {
    &-verified {
      color: var(--ds-color--P0);
      cursor: pointer;
      margin-left: 20px;
    }

    &-phone-verified {
      display: flex;
      width: 400px;
    }

    &-input {
      flex: 1;
    }

    &-verified-text {
      display: inline-block;
      width: 90px;
      text-align: center;
      font-size: 12px;
    }

    &-warn {
      color: var(--ds-color--A0);
    }

    &-box-ul {
      list-style: none;
      width: 90%;
      display: flex;
      flex-wrap: wrap;
      // width: 800px;
    }

    &-box-li {
      list-style: none;
      width: 16.6%;
      box-sizing: border-box;
      padding: 5px 5px 15px 0;

      &-title {
        color: var(--ds-color-A--text-tertiary);
        font-size: 13px;
        line-height: 25px;
      }

      &-desc {
        color: var(--ds-color-A--text-secondary);
        font-size: 13px;
        line-height: 25px;
      }
    }

    &-account {
      display: flex;
      align-items: center;

      &-list {
        display: flex;
        align-items: center;
        padding-right: 30px;

        i {
          color: var(--ds-color--P0);
          font-size: 28px;
          padding-right: 6px;
        }
      }

      &-user {
        font-size: 0;
        display: flex;
        flex-direction: column;
        align-items: baseline;
      }

      &-name {
        line-height: 14px;
        height: 14px;
        padding: 0;
        font-size: 12px;
      }
    }
  }
  &__title {
    font-size: 20px;
    font-weight: bold;
    color: #333333;
    margin: 34px 0 16px 0;
  }

  &__border {
    border-bottom: 1px solid #eee;
  }

  &__button {
    margin-left: 20px;
  }
}
</style>
